let localExpelPending = false

export const markLocalExpelPending = (): void => {
    localExpelPending = true
}

export const isLocalExpelPending = (): boolean => localExpelPending

export const consumeLocalExpelPending = (): boolean => {
    if (!localExpelPending) {
        return false
    }

    localExpelPending = false
    return true
}

export const resetZoomDiagnosticsSessionContext = (): void => {
    localExpelPending = false
}
